import React from 'react';
import {
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { useSelector, useDispatch } from 'react-redux';

import { useHistory } from 'react-router-dom';
import { logout } from 'modules/auth/auth.actions';


const Dropdown = () => {
  const dispatch = useDispatch();
  const email = useSelector((state) => state.auth.user.email);
  const history = useHistory();

  return (
    <CDropdown className="align-self-center mr-3 bg-white">
      <CDropdownToggle caret={false}>
        <>
          {email}
        </>
      </CDropdownToggle>
      <CDropdownMenu placement="left-start" className="bg-white dropdown-menu-custom ">
        <CDropdownItem onClick={() => history.push('#')}>
          <CIcon name="cil-user" height="18" alt="User Profile" color="black" className="mr-2" />
          Mój profil
        </CDropdownItem>
        <CDropdownItem divider />
        <CDropdownItem onClick={() => dispatch(logout())}>
          <CIcon name="cil-power-standby" height="18" alt="Logout" color="black" className="mr-2" />
          Wyloguj
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};
export default Dropdown;
